/**
 * web-client-app D5 — the studio website's entry (web.html). The server writes
 * the studio's look, the page's preview tags and the boot block into the shell;
 * this mounts the pages. No Telegram code is ever imported here
 * (scripts/check-web-no-telegram.mjs).
 */
// The pieces' base first: it declares the `telify` cascade layer before any piece's CSS.
import './styles/base.css';
import './styles/web.css';
// Wallets plan code fix 2: Stripe's payment secret leaves the address before the router reads it.
import '../lib/stripeReturnBootstrap';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// The same self-hosted fonts the Mini App uses (EB Garamond display, Outfit UI).
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
import '@fontsource/eb-garamond/400.css';
import '@fontsource/eb-garamond/500.css';
import '@fontsource/eb-garamond/600.css';
import '@fontsource/eb-garamond/400-italic.css';

import { WebApp } from './WebApp';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WebApp />
  </StrictMode>,
);
